import React from "react";
import { DateTime } from "luxon";

import { sort as sortData } from "@common/sort";
import { filter as filterData } from "@common/filter";
import { useUtils } from "@common/treeToggle";
import { Context } from "../context";
import { ProjectCtx } from "../projectCtx";
import { renderWithTreeCtx } from "../utils";
import { Props } from "./types";
import { Details } from "./details";
import styles from "./styles.scss";

function DetailsView({ projects: p, filter, sort }: Props) {
  const { cell } = React.useContext(Context);
  const { isOpen } = useUtils();

  const projects = sortData(
    sort,
    filterData(p, filter, (project) => ({ project })),
    (project) => ({
      name: project.name,
      startDate: project.rootList.startDate,
      endDate: project.rootList.endDate,
    }),
  );

  return (
    <div className={styles.detailsView}>
      {projects.map((project, projectIndex) => (
        <ProjectCtx
          key={project.uuid}
          project={project}
          filter={filter}
          sort={sort}
          isMultiProject={projects.length > 1}
          isFlagRendered={false}
        >
          {(gantt, isFetching) =>
            renderWithTreeCtx(gantt, isOpen, (projectElement, ctx) => (
              <div key={projectElement.uuid} style={{ height: cell.height }}>
                <Details
                  element={projectElement}
                  projects={projects}
                  projectTimezone={
                    project.timeZone || DateTime.local().zoneName
                  }
                  {...ctx}
                />
              </div>
            ))
          }
        </ProjectCtx>
      ))}
    </div>
  );
}

export { DetailsView };
